import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import { ATTENDANCE_SERVICE } from '../EndPoints';

export const CreateAttendanceShift = createAsyncThunk("attendanceShift/createAttendanceShift",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(ATTENDANCE_SERVICE.createAttendanceShift, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateAttendanceShift = createAsyncThunk("attendanceShift/updateAttendanceShift",async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(ATTENDANCE_SERVICE.updateAttendanceShift, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});


export const GetAttendanceShiftById = createAsyncThunk('attendanceShift/getAttendanceShiftById', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(`${ATTENDANCE_SERVICE.getAttendanceShiftById}${params}`).then((response) => {
        return response;
    }).catch((error) => {
        return error.response;
    });
    const { data, status } = response;
    return { data, status };
});

// Not-assigned shift resources (Read). Body:
// { pagination:{page,size}, model, resourceId, resourceString, key }. Used by
// the Add tab in update mode so the catalog excludes already-assigned items.
// Mirrors Devices GetNoAssigned.
export const GetShiftResourceNotAssigned = createAsyncThunk('attendanceShift/getShiftResourceNotAssigned', async (body) => {
    const response = await apiInstance.post(ATTENDANCE_SERVICE.getShiftResourceNotAssigned, body).then((response) => {
        return response;
    }).catch((error) => {
        return error.response;
    });
    const { data, status } = response;
    return { data, status };
});

// Assigned shift resources (CustomRead). Body:
// { pagination:{page,size}, model, resourceId, resourceString } (key must be null).
// Uniform shape discriminated by shiftResourceMode. Mirrors Devices GetAssigned.
export const GetShiftResourceAssigned = createAsyncThunk('attendanceShift/getShiftResourceAssigned', async (body) => {
    const response = await apiInstance.post(ATTENDANCE_SERVICE.getShiftResourceAssigned, body).then((response) => {
        return response;
    }).catch((error) => {
        return error.response;
    });
    const { data, status } = response;
    return { data, status };
});
